<template>
  <job-page-error-container v-if="jobErrorState"></job-page-error-container>
  <div v-else>
    <job-page-header-container :show-back-button="$mq.phone && showBackButton" :job-applied="jobApplied"></job-page-header-container>
    <job-page-content-container :show-back-button="!$mq.phone && showBackButton" :job-applied="jobApplied"></job-page-content-container>
  </div>
</template>

<script>

import {isEmpty} from 'lodash';
import redirects from 'top20common/distribution/services/redirects';
import {mapGetters} from 'vuex';

import JobPageContentContainer from './JobPageContentContainer';
import JobPageErrorContainer from './JobPageErrorContainer';
import JobPageHeaderContainer from './JobPageHeaderContainer';

const REFER = 'refer';

export default {
  created() {
    this.$mam.trackJobPageVisit(this.$route.query.utm_medium);
    this.getJobData().then(() => this.redirectIfRefer());

    if (this.isCandidateUser) {
      this.$store.dispatch('getApplicationsAction');
      this.$store.dispatch('getProfileAction');
      this.$store.dispatch('getRecommendedJobsListInBackgroundAction');
      this.$store.dispatch('getReferrerAction');
    } else {
      this.$store.dispatch('getReferralPotentialBonusAction', this.jobCodeAndAction);
    }
  },
  beforeDestroy() {
    this.$store.commit('setJobDetailsState', null);
    this.$store.commit('mutateJobMetaState', null);
    this.$store.commit('mutateJobErrorState', null);
  },
  computed: {
    ...mapGetters([
      'jobErrorState',
      'jobDetailsState',
      'isCandidateUser',
      'isLoggedIn',
      'previousRouteNameState',
      'applicationsListState'
    ]),
    jobCodeAndAction() {
      return {
        jobCode: this.jobCode,
        action: REFER
      };
    },
    jobCode() {
      return this.$route.params.code;
    },
    showBackButton() {
      if (!isEmpty(this.jobDetailsState)) {
        return this.canGoBackToPreviousRoute;
      }
    },
    canGoBackToPreviousRoute() {
      return this.previousRouteNameState === 'referral' || this.previousRouteNameState === 'jobs';
    },
    jobApplied() {
      for (let app of this.applicationsListState) {
        if (app.code === this.jobDetailsState.code) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    getJobData() {
      return this.$store
        .dispatch('getJobAction', this.jobCode)
        .then(job => {
          this.setDocumentTitle(job.title);
          return job;
        })
        .catch(() => {
          this.$mam.track404();
        });
    },
    setDocumentTitle(title) {
      document.title = `${title} - ${this.$context.title}`;
    },
    redirectIfRefer() {
      if (this.$route.query.action === REFER && !this.isCandidateUser) {
        redirects.saveTargetRouteBeforeLogin(this.$route.path);
        redirects.goToCandidateRegister(null, null, null, `action=${REFER}&job_code=${this.jobCode}`);
      }
    }
  },
  components: {
    JobPageErrorContainer,
    JobPageContentContainer,
    JobPageHeaderContainer
  }
};
</script>
